import axios from 'axios'
import { apiObject, moveableObject } from './apiobject'

const formtemplate = {
  ...apiObject,
  url: '/forms/templates/',
  downloadImportFile (obj, type = "create") {
    return axios.get(`${this.url}${obj.id}/importtemplate/`, {
      params: {
        "type": type
      },
      responseType: 'arraybuffer'
    })
  },
  duplicate (obj, name = null) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${obj.id}/duplicate/`, {
        name: name
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const section = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/sections/'
}

const question = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/questions/'
}

const paragraph = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/paragraphs/'
}

const pagebreak = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/pagebreak/'
}

const esignature = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/esignature/'
}

const optionList = {
  ...apiObject,
  url: '/forms/optionlists/',
  addOptions (optionListId, options) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${optionListId}/addoptions/`, { options })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const fieldType = {
  ...apiObject,
  ...moveableObject,
  url: '/forms/fieldtypes/',
  named (name, page=1) {
    return new Promise((resolve, reject) => {
      let url = '/forms/fieldtypes/named/'
      axios.get(url, {
        params: {
          name: name,
          page: page
        },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  formtemplate,
  section,
  question,
  esignature,
  optionList,
  fieldType,
  paragraph,
  pagebreak
}
